import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=logged
  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get('/auth/me');
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    // If returning from Emergent OAuth, skip /me here — AuthCallback exchanges first.
    if (typeof window !== 'undefined' && window.location.hash?.includes('session_id=')) {
      setUser(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    if (data.access_token) localStorage.setItem('agn_token', data.access_token);
    setUser(data);
    return data;
  };
  const register = async (payload) => {
    const { data } = await api.post('/auth/register', payload);
    if (data.access_token) localStorage.setItem('agn_token', data.access_token);
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await api.post('/auth/logout'); } catch {}
    localStorage.removeItem('agn_token');
    setUser(false);
  };
  const refresh = checkAuth;

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
